import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = '';

export default function Agents() {
  const [agents, setAgents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editAgent, setEditAgent] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', phone: '', role: 'teammate', password: '', department: 'general' });
  const businessId = JSON.parse(localStorage.getItem('vflow_business') || '{}').id;

  useEffect(() => { fetchAgents(); }, []);

  const fetchAgents = async () => {
    const res = await axios.get(`${API}/api/agents/${businessId}`);
    setAgents(res.data.agents);
  };

  const handleSubmit = async () => {
    if (editAgent) {
      await axios.put(`${API}/api/agents/${editAgent.id}`, form);
    } else {
      await axios.post(`${API}/api/agents`, { ...form, business_id: businessId });
    }
    setShowForm(false);
    setEditAgent(null);
    setForm({ name: '', email: '', phone: '', role: 'teammate', password: '', department: 'general' });
    fetchAgents();
  };

  const handleEdit = (agent) => {
    setEditAgent(agent);
    setForm({ name: agent.name, email: agent.email, phone: agent.phone, role: agent.role, password: '', department: agent.department || 'general' });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this agent?')) {
      await axios.delete(`${API}/api/agents/${id}`);
      fetchAgents();
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>Agents</h2>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>Manage your team members</p>
        </div>
        <button onClick={() => { setShowForm(true); setEditAgent(null); setForm({ name: '', email: '', phone: '', role: 'teammate', password: '', department: 'general' }); }}
          style={{ background: '#25D366', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' }}>
          + Add Agent
        </button>
      </div>

      {showForm && (
        <div style={{ background: '#f9f9f9', border: '1px solid #eee', borderRadius: '10px', padding: '16px', marginBottom: '20px' }}>
          <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>{editAgent ? 'Edit Agent' : 'New Agent'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <input placeholder="Full name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }} />
            <input placeholder="Phone number" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }} />
            <input placeholder="Email address" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }} />
            <input placeholder="Password" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }} />
            <select value={form.department} onChange={e => setForm({ ...form, department: e.target.value })}
              style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}>
              <option value="general">General</option>
              <option value="telecaller">Telecaller</option>
              <option value="sales">Sales</option>
              <option value="support">Support</option>
            </select>
            <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
              <option value="teammate">Teammate</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
            <button onClick={handleSubmit}
              style={{ background: '#25D366', color: 'white', border: 'none', padding: '8px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>
              Save Agent
            </button>
            <button onClick={() => { setShowForm(false); setEditAgent(null); }}
              style={{ background: '#eee', border: 'none', padding: '8px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {agents.length === 0 ? (
          <div style={{ padding: '32px', textAlign: 'center', color: '#999', background: '#fff', border: '1px solid #eee', borderRadius: '14px' }}>No agents found</div>
        ) : agents.map(agent => (
          <div key={agent.id} style={{ background: '#fff', border: '1px solid #eee', borderRadius: '14px', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: '#E1F5EE', color: '#0F6E56', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: 500 }}>
                {agent.name?.charAt(0).toUpperCase()}
              </div>
              {agent.online_status && (
                <div style={{ position: 'absolute', bottom: '-1px', right: '-1px', width: '12px', height: '12px', borderRadius: '50%', background: agent.online_status === 'online' ? '#22C55E' : '#9CA3AF', border: '2px solid #fff' }} />
              )}
            </div>
            <div style={{ flex: 1, minWidth: '160px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontWeight: 500, fontSize: '14px' }}>{agent.name}</span>
                <span style={{ background: agent.role === 'admin' ? '#EEEDFE' : '#f0f0f0', color: agent.role === 'admin' ? '#3C3489' : '#555', padding: '2px 8px', borderRadius: '20px', fontSize: '11px' }}>
                  {agent.role}
                </span>
              </div>
              <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#888' }}>{agent.phone} · {agent.email}</p>
              <p style={{ margin: '2px 0 0', fontSize: '11px', color: agent.online_status === 'online' ? '#16a34a' : '#9CA3AF' }}>
                {agent.online_status === 'online' ? 'Online' : 'Offline'}
              </p>
            </div>
            <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', alignItems: 'center' }}>
              <span style={{ fontSize: '13px', fontWeight: 500, marginRight: '2px' }}>{agent.total_leads || 0} leads</span>
              {agent.hot_leads > 0 && <span style={{ fontSize: '11px', background: '#FCEBEB', color: '#791F1F', padding: '3px 9px', borderRadius: 999, fontWeight: 500 }}>{agent.hot_leads} hot</span>}
              {agent.warm_leads > 0 && <span style={{ fontSize: '11px', background: '#FAEEDA', color: '#633806', padding: '3px 9px', borderRadius: 999, fontWeight: 500 }}>{agent.warm_leads} warm</span>}
              {agent.cold_leads > 0 && <span style={{ fontSize: '11px', background: '#F1EFE8', color: '#5F5E5A', padding: '3px 9px', borderRadius: 999, fontWeight: 500 }}>{agent.cold_leads} cold</span>}
              {agent.converted_leads > 0 && <span style={{ fontSize: '11px', background: '#EAF3DE', color: '#27500A', padding: '3px 9px', borderRadius: 999, fontWeight: 500 }}>{agent.converted_leads} won</span>}
            </div>
            <div style={{ display: 'flex', gap: '12px', marginLeft: '8px' }}>
              <span onClick={() => handleEdit(agent)} style={{ cursor: 'pointer', color: '#555' }}>✏️</span>
              <span onClick={() => handleDelete(agent.id)} style={{ cursor: 'pointer', color: '#e53e3e' }}>🗑️</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
